import angular from "angular";
import SamoodpocetCtrl from "./SamoodpocetCtrl";
import RkCtrl from "./RkCtrl";
import "./style.css";
import ReportingCtrl from "../Reporting/ReportingCtrl";

export default angular.module("energis.home", [])
.config(function routing($urlRouterProvider, $locationProvider, $stateProvider) {
  //$locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise('/');
  $stateProvider
  .state("home",{
    url:"/",
    template: require("../Reporting/measurement.html"),
    controller: ReportingCtrl,
    controllerAs: "ctrl"
  })
  .state("samoodpocet-plyn",{
    url:"/samoodpocet-plyn",
    template: require("./home.html"),
    controller: SamoodpocetCtrl,
    controllerAs: "ctrl",
    params:{
      typ: "PLYN"
    }
  })
  .state("samoodpocet-ee",{
    url:"/samoodpocet-ee",
    template: require("./home.html"),
    controller: SamoodpocetCtrl,
    controllerAs: "ctrl",
    params:{
      typ: "EE"
    }
  })
  .state("kapacita", {
    url: "/kapacita",
    template: require("./home.html"),
    controller: RkCtrl,
    controllerAs: "ctrl"
  })
  .state("kapacita-plyn", {
    url: "/kapacita-plyn",
    template: require("./home.html"),
    controller: RkCtrl,
    controllerAs: "ctrl",
    params:{
      typ: "PLYN"
    }
  })
  .state("kapacita-ee", {
    url: "/kapacita-ee",
    template: require("./home.html"),
    controller: RkCtrl,
    controllerAs: "ctrl",
    params:{
      typ: "EE"
    }
  })
})
.name


// WEBPACK FOOTER //
// ./src/Home/index.js